module.exports = __webpack_public_path__ + "img/banner_jd02.dcb37baf.png";